// ============================
// DTF Image Arranger Configuration
// ============================

// Printer identification
export const PRINTER_NAME = 'DTF-24H2';

// ============================
// Sheet dimensions (inches)
// ============================
// Width and height of each printable sheet
export const SHEET_WIDTH_IN = 22;
export const SHEET_HEIGHT_IN = 72;

// ============================
// Print resolution (DPI)
// ============================
// Uniform DPI for both axes, or specify separately:
export const DPI = 300;          // Standard high-quality DPI
// Override to use 300 PPI (pixels per inch) uniformly
export const DPI_X = 720;
export const DPI_Y = 1800;

// ============================
// Printer capabilities
// ============================
export const PRINTER_MAX_DPI_X = 720;
export const PRINTER_MAX_DPI_Y = 1800;
export const PRINTER_MAX_WIDTH_IN = 22;
export const PRINTER_MAX_HEIGHT_IN = 72;

// ============================
// Unit conversion
// ============================
// Inches to meters for PNG pHYs metadata
export const INCH_TO_METER = 0.0254;
// Override pixels-per-unit based on reference image (6601px corresponds to known unit)
export const PPU_X = Math.round(DPI / INCH_TO_METER);
export const PPU_Y = Math.round(DPI / INCH_TO_METER);
export const PHYS_UNIT = 1; // 1 = meters

// ============================
// Canvas settings
// ============================
// Computed page pixel dimensions
export const PAGE_WIDTH_PX = SHEET_WIDTH_IN * (typeof DPI_X !== 'undefined' ? DPI_X : DPI);
export const PAGE_HEIGHT_PX = SHEET_HEIGHT_IN * (typeof DPI_Y !== 'undefined' ? DPI_Y : DPI);

// Preview scale (for on-screen thumbnails)
export const PREVIEW_SCALE = 0.2;
export const PREVIEW_MAX_WIDTH_PX = 640;

// ============================
// Layout margins & gaps
// ============================
// Inches for page margin
export const PAGE_MARGIN_IN = 0.25;
// Convert margin to pixels
export const PAGE_MARGIN_PX = PAGE_MARGIN_IN * (typeof DPI_X !== 'undefined' ? DPI_X : DPI);

// Pixel padding between images
export const IMAGE_PADDING_PX = 15;
export const IMAGE_GAP_PX = 10;

// ============================
// File naming & upload
// ============================
// Prefix for sheet images
export const FILE_PREFIX = 'DTF_Sheet';
// Date format to append (e.g., YYYYMMDD_HHmmss)
export const DATE_FORMAT = 'YYYYMMDD_HHmmss';

// ============================
// Pricing (optional)
// ============================
// Default cost rate per square inch
export const DEFAULT_RATE_PER_SQIN = 0.04;

// ============================
// Defaults
// ============================
// Default image quantity
export const DEFAULT_QUANTITY = 1;

// ============================
// Exported as default for brevity
// ==========================